import template from './vehicleEdit.html';
import controller from './vehicleEdit.controller';
import './vehicleEdit.styl';

let vehicleEditComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default vehicleEditComponent;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/vehicleEdit.component.js